import { render, staticRenderFns } from "./PackSizeSettings.vue?vue&type=template&id=65bb5c06&scoped=true&"
import script from "./PackSizeSettings.vue?vue&type=script&lang=js&"
export * from "./PackSizeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bb5c06",
  null
  
)

export default component.exports